<div class="ws-popup-header">
  <div class="appointment-title" *ngIf="appointment">{{appointment?.title}}</div>
  <div class="appointment-title" *ngIf="!appointment">{{'New appointment' | translate}}</div>

  <div class="actions">
    <button mat-icon-button (click)="syncAppointmentClicked()" [wsTooltip]="'Sync external calendar' | translate"
      [ngClass]="{spinning: isSyncingInBackground}" *ngIf="appointment">
      <mat-icon>sync</mat-icon>
    </button>
    <button mat-icon-button (click)="deleteAppointmentClicked()" *ngIf="appointment">
      <mat-icon>delete</mat-icon>
    </button>
    <button mat-icon-button (click)="cancelClicked()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<mat-sidenav [fixedInViewport]="true" #clientSideNav position="end">
  <app-new-contact-sidenav [wineryId]="login?.company?.id" [contact]="contact" [isAppointment]="true"
    (close)="clientCloseClicked($event)">
  </app-new-contact-sidenav>
</mat-sidenav>


<div class="ws-popup-content add-appointment-wrapper" [formGroup]="form">
  <div class="add-appointment-fields-wrapper">
    <div class="field-combo">
      <div class="field-wrapper">
        <label for="title">
          {{'Title' | translate}}
        </label>
        <input id="title" type="text" formControlName="title">
      </div>

      <div class="field-wrapper">
        <label for="place">
          {{'Place' | translate}}
        </label>
        <input id="place" type="text" formControlName="place">
      </div>
    </div>


    <div class="field-combo">
      <div class="field-wrapper">
        <label for="start_date">
          {{'Start date' | translate}}
        </label>
        <input (focus)="startPicker.open()" [matDatepicker]="startPicker" id="start_date" type="text" [min]="now"
          required [(ngModel)]="startDate" [ngModelOptions]="{ standalone: true }">
      </div>
      <div class="field-wrapper">
        <label for="start_time">
          {{'Start Time' | translate}}
        </label>
        <input required id="start_time" type="time" [(ngModel)]="startTime" [ngModelOptions]="{ standalone: true }"
          [disabled]="!startDate">
      </div>
    </div>

    <div class="field-combo">
      <div class="field-wrapper">
        <label for="end_date">
          {{'End date' | translate}}
        </label>
        <input (focus)="endPicker.open()" [min]="startDate" [matDatepicker]="endPicker" id="end_date" type="text"
          [(ngModel)]="endDate" [ngModelOptions]="{ standalone: true }"
          [disabled]="!startDate || this.form.get('allDay')?.value" required>
      </div>
      <div class="field-wrapper time-input">
        <label for="end_time">
          {{'End Time' | translate}}
        </label>
        <input required id="end_time" type="time" [(ngModel)]="endTime" [ngModelOptions]="{ standalone: true }"
          [disabled]="!startDate || !endDate || this.form.get('allDay')?.value">
      </div>
    </div>

    <div class="field-combo">
      <div class="field-wrapper horizontal">
        <label for="all_day">
          {{'All day' | translate}}
        </label>
        <mat-checkbox formControlName="allDay" id="all_day"></mat-checkbox>
      </div>
    </div>
    <div class="field-wrapper" [ngClass]="{ 'no-employees': !employees || employees.length === 0 }">
      <label for="employee">
        {{ 'Employee' | translate }}
      </label>
      <mat-select formControlName="employeeId" id="employee"
        [wsTooltip]="(!employees || employees.length === 0) ? 'Nessun addetto presente' : ''">
        <mat-option *ngFor="let employee of employees" [value]="employee.id">
          {{ employee.firstName }} {{ employee.lastName }}
        </mat-option>
      </mat-select>
    </div>

    <div class="client-wrapper">
      <div class="field-wrapper">
        <div class="title" *ngIf="hasClient">
          <label>{{'Client' | translate }}</label>
        </div>

        <div class="client-data" *ngIf="hasClient">
          <div class="row flex-column">
            <p class="full-name">{{clientLabel}}</p>
            <small class="email">{{form.get('email')?.value}}</small>
            <span class="phone">{{form.get('phone')?.value}}</span>
            <span class="country" *ngIf="form.get('countryIso')?.value">{{form.get('countryIso')?.value}}</span>
            <span class="marketing" *ngIf="form.get('manualMarketing')?.value">
              <mat-icon style="font-size: 16px; height: 16px; width: 16px; vertical-align: middle;">check_circle</mat-icon>
              {{'Marketing consent' | translate}}
            </span>
          </div>
          <div class="row">
            <button mat-icon-button (click)="editClientClicked()">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button (click)="removeClientClicked()">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <div class="client-search-wrapper" *ngIf="!hasClient">
          <label>{{ 'Search client' | translate }}</label>
          <div class="input-search-wrapper">
            <input #trigger="matAutocompleteTrigger" type="text" [formControl]="searchControl"
              (focus)="trigger.openPanel(); onClientSearchFocus()" [matAutocompleteDisabled]="false" [matAutocomplete]="clientAutoComplete"
              autocomplete="chrome-off" />

            <div class="actions">
              <ws-button class="addModifySearchButton" mat-stroked-button type="button" [callToActionType]="'tertiary'"
                (click)="addNewClientClicked()">
                {{ 'Add new client' | translate }}
              </ws-button>
            </div>
          </div>

          <mat-autocomplete #clientAutoComplete="matAutocomplete" class="autocomplete-new-client"
            panelWidth="506px" [displayWith]="contactName" (optionSelected)="patchContact($event.option.value)">
            <mat-option *ngFor="let contact of contacts" [value]="contact">
              <div class="client-preview">
                <p class="full-name">{{ contact.name }}</p>
                <small class="email">{{ contact.email }}</small>
                <span class="actions"><i class="icon-plus color-base-5"></i></span>
              </div>
            </mat-option>

            <mat-option *ngIf="loadingClients" class="loading" disabled>
              <mat-spinner diameter="35"></mat-spinner>
            </mat-option>

            <mat-option class="no-results-wrapper" disabled
              *ngIf="contacts.length === 0 && !loadingClients && !searchControl.pristine">
              <span>{{ 'No user found' | translate }}</span>
            </mat-option>

            <mat-option class="loading" *ngIf="searchControl.pristine" disabled></mat-option>
          </mat-autocomplete>
        </div>

        <div class="field-wrapper">
          <label for="notes">
            {{ 'Notes' | translate }}
          </label>
          <textarea formControlName="notes" id="notes"></textarea>
        </div>

      </div>
      <div class="ws-popup-footer">
        <span></span>
        <div>
          <ws-button [callToActionType]="'danger'" (click)="cancelClicked()">
            {{ 'Cancel' | translate }}
          </ws-button>
          <ws-button class="ml10" [callToActionType]="'primary'" [disabled]="form.invalid" (click)="saveClicked()">
            {{ 'Save' | translate}}
          </ws-button>
        </div>
      </div>
    </div>

    <mat-datepicker #startPicker></mat-datepicker>
    <mat-datepicker #endPicker></mat-datepicker>